module.exports = __webpack_public_path__ + "fonts/dxiconsmaterial.ade00e8f.ttf";